<template>
  <div>
    <!-- Mobile: Dropdown with burger -->
    <Dropdown
      v-if="isSmallerScreen"
      overlayClasses="shrink-0 top-[42px] left-[-11px] ml-[-11px]"
      align="left"
      width="48"
      contentClasses="py-4 shadow-[0px_40px_80px_-8px_color-mix(in_srgb,_var(--color-disabled)_24%,_transparent)]"
      @menuStateChange="handleMenuStateChange"
    >
      <template #trigger>
        <div class="flex items-center justify-center gap-2 my-auto shrink-0">
          <MenuToggle @toggle="handleToggle" />
        </div>
      </template>
      <template #content>
        <component
          :is="componentName"
          class="flex-auto"
          @dropdown-open="handleDropdownOpen"
          @is-collapsed="collapsingSidebar"
        />
      </template>
    </Dropdown>

    <!-- Desktop: Direct rendering -->
    <component
      v-else
      :is="componentName"
      class="flex-auto"
      @dropdown-open="handleDropdownOpen"
      @is-collapsed="collapsingSidebar"
    />
  </div>
</template>

<script>
import Dropdown from '@/Components/Dropdown.vue';
import MenuToggle from '@/Components/MenuToggle.vue';
import NavCandidate from '@/Layouts/Navigation/NavCandidate.vue';
import NavHR from '@/Layouts/Navigation/NavHR.vue';
import NavAdmin2 from '@/Layouts/Navigation/NavAdmin2.vue';
export default {
  name: 'NavTopMenu',
  components: {
    Dropdown,
    MenuToggle,
    NavCandidate,
    NavHR,
    NavAdmin2,
  },
  props: {
    navComponent: {
      type: String,
      required: true,
      validator: (value) => ['candidate', 'hr', 'admin2'].includes(value),
    },
  },
  emits: ['dropdown-open', 'menuStateChange', 'toggle', 'collapsingSidebar'],
  data() {
    return {
      isSmallerScreen: false,
    };
  },
  computed: {
    componentName() {
      if (this.navComponent === 'hr') return 'NavHR';
      if (this.navComponent === 'admin2') return 'NavAdmin2';
      return 'NavCandidate';
    },
  },
  methods: {
    checkScreenSize() {
      this.isSmallerScreen = window.innerWidth < 1024;
    },
    handleDropdownOpen(isOpen) {
      this.$emit('dropdown-open', isOpen);
    },
    handleMenuStateChange(isOpen) {
      this.$emit('menuStateChange', isOpen);
    },
    handleToggle() {
      this.$emit('toggle');
    },
    collapsingSidebar(isCollapsed) {
      this.$emit('collapsingSidebar', isCollapsed);
    },
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
};
</script>
